




















































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { userModule } from "@/store/modules/user";
import { storeDokter } from "@/store/modules/dokter";
import { storeSuratRujukanEdukasi } from "@/store/modules/SuratRujukanEdukasiStore";
import SuratRujukanEdukasiSvc from "@/services/SuratRujukanEdukasi";

@Component({
  inject: { isReadOnly: { default: () => () => false } }
})
export default class RujukanEdukasiInputModal extends Vue {
  @Prop() readonly value!: boolean;
  @Prop() register!: string;
  @Prop() rm!: string;
  @Prop({ default: null }) editData: any;

  isReadOnly!: () => boolean;

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  tujuan_text = "";
  tatalaksana: { uid: number; text: string }[] = [{ uid: 1, text: "" }];
  uidSeq = 1;
  dpjp_id: number = null;
  mpp_id: number = null;
  mppOptions: { id: number; nama: string }[] = [];
  saving = false;
  requiredRule = [v => !!v || "*Kolom ini harus diisi"];

  get dialog() {
    return this.value;
  }

  set dialog(value) {
    this.$emit("input", value);
  }

  get listDokter() {
    return storeDokter.list;
  }

  get listMpp() {
    const list = [...this.mppOptions];
    const editMpp = this.editData?.mpp;

    if (editMpp?.id && !list.some(item => item.id === editMpp.id)) {
      list.unshift({ id: editMpp.id, nama: editMpp.nama });
    }

    return list;
  }

  async loadMpp() {
    try {
      this.mppOptions = await SuratRujukanEdukasiSvc.listMpp();
    } catch {
      this.mppOptions = [];
    }
  }

  get storeUser() {
    return userModule.user;
  }

  @Watch("value")
  onDialogOpen(val) {
    if (val) {
      this.loadMpp();

      if (this.editData) {
        this.tujuan_text = this.editData.tujuan_text || "";
        this.setTatalaksana(this.editData.edukasi_diharapkan || []);
        this.dpjp_id = this.editData.dpjp?.id || null;
        this.mpp_id = this.editData.mpp?.id || null;
      } else {
        this.clearInput();
        if (this.storeUser?.profesi === "Dokter") {
          this.dpjp_id = this.storeUser.id;
        }
      }
    }
  }

  addTatalaksana() {
    this.uidSeq += 1;
    this.tatalaksana.push({ uid: this.uidSeq, text: "" });
  }

  removeTatalaksana(idx: number) {
    if (this.tatalaksana.length === 1) return;
    this.tatalaksana.splice(idx, 1);
  }

  setTatalaksana(items: string[]) {
    const rows = (items || [])
      .filter(t => !!t)
      .map(text => ({ uid: ++this.uidSeq, text }));
    this.tatalaksana = rows.length ? rows : [{ uid: ++this.uidSeq, text: "" }];
  }

  get input() {
    const edukasi = this.tatalaksana
      .map(row => (row.text || "").trim())
      .filter(text => !!text);

    return {
      register_id: this.register,
      pasien_rm: this.rm,
      tujuan_text: this.tujuan_text,
      edukasi_diharapkan: edukasi,
      dpjp_id: this.dpjp_id,
      mpp_id: this.mpp_id
    };
  }

  async save() {
    if (this.readOnly) return;
    const form = this.$refs.form as any;
    if (!form.validate()) return;

    if (this.saving) return;
    this.saving = true;

    try {
      const existingSurat = storeSuratRujukanEdukasi.surat;

      const resp = existingSurat
        ? await SuratRujukanEdukasiSvc.update(existingSurat.id, this.input)
        : await SuratRujukanEdukasiSvc.create(this.input);

      if (resp.data.status == "1") {
        await storeSuratRujukanEdukasi.getByRegister(this.register);
        this.dialog = false;
        this.$emit("saved");
      }
    } finally {
      this.saving = false;
    }
  }

  clearInput() {
    this.tujuan_text = "";
    this.setTatalaksana([]);
    this.dpjp_id = null;
    this.mpp_id = null;
  }

  close() {
    this.dialog = false;
  }
}
